import { SIGNED_DISPOSITION_NOT_RETAINED } from './safetyScanProductPresentation';

const PENDING_LIKE = new Set([
  '',
  'pending',
  'pending review',
  'pending_review',
  'unknown',
  'not reviewed yet',
]);

export function formatSignedEvidenceDisposition(value?: string | null): string {
  const raw = String(value || '').trim();
  const key = raw.toLowerCase().replace(/[-\s]+/g, '_');
  if (!raw || PENDING_LIKE.has(raw.toLowerCase()) || PENDING_LIKE.has(key)) {
    return SIGNED_DISPOSITION_NOT_RETAINED;
  }
  if (key === 'true_event' || key === 'confirmed' || key === 'confirmed_true_event') {
    return 'Confirmed true event';
  }
  if (key === 'false_positive') return 'False positive';
  if (key === 'duplicate') return 'Duplicate';
  if (key === 'insufficient_evidence' || key === 'needs_more_review' || key === 'unreviewable') {
    return 'Needs more review';
  }
  if (key === 'expected_activity' || key === 'authorized') return 'Expected activity';
  return raw.replace(/_/g, ' ').replace(/\b\w/g, (match) => match.toUpperCase());
}

export function signedDispositionLooksPending(value?: string | null): boolean {
  return formatSignedEvidenceDisposition(value) === SIGNED_DISPOSITION_NOT_RETAINED;
}
